import { call, put } from 'redux-saga/effects';
import { actions } from 'store/loading';
import * as Actions from './actions';
import API from 'utils/api';
import { ICreateWebhookDto, IUpdateWebhookDto } from 'types';

export function* ensureGetWebhooks({
  payload = {},
}: {
  payload?: { noLoader?: boolean };
  type?: typeof Actions.getWebhooks.TRIGGER;
} = {}) {
  const noLoader = !!payload?.noLoader;
  try {
    if (!noLoader) yield put(actions.tabLoading(true));
    const data = yield call(API.webhooks.list);
    yield put(Actions.getWebhooks.success(data));
  } catch (err) {
    yield put(Actions.getWebhooks.failure(err));
  } finally {
    if (!noLoader) yield put(actions.tabLoading(false));
  }
}

export function* ensureGetWebhookById({
  payload,
}: {
  payload: string;
  type: typeof Actions.getWebhookById.TRIGGER;
}) {
  try {
    const data = yield call(API.webhooks.get, payload);
    yield put(Actions.getWebhookById.success(data));
  } catch (err) {
    yield put(Actions.getWebhookById.failure(err));
  }
}

export function* ensureCreateWebhook({
  payload,
}: {
  payload: ICreateWebhookDto;
  type: typeof Actions.createWebhook.TRIGGER;
}) {
  try {
    const data = yield call(API.webhooks.create, payload);
    yield call(ensureGetWebhooks);
    yield put(Actions.createWebhook.success(data));
  } catch (err) {
    yield put(Actions.createWebhook.failure(err));
  }
}

export function* ensureUpdateWebhook({
  payload,
}: {
  payload: { id: string; data: IUpdateWebhookDto };
  type: typeof Actions.updateWebhook.TRIGGER;
}) {
  try {
    const data = yield call(API.webhooks.update, payload);
    yield call(ensureGetWebhooks);
    yield put(Actions.updateWebhook.success(data));
  } catch (err) {
    yield put(Actions.updateWebhook.failure(err));
  }
}

export function* ensureDeleteWebhook({
  payload,
}: {
  payload: string;
  type: typeof Actions.deleteWebhook.TRIGGER;
}) {
  try {
    yield call(API.webhooks.remove, payload);
    yield put(Actions.deleteWebhook.success(payload));
  } catch (err) {
    yield put(Actions.deleteWebhook.failure(err));
  }
}

export function* ensureTestWebhook({
  payload,
}: {
  payload: string;
  type: typeof Actions.testWebhook.TRIGGER;
}) {
  try {
    const data = yield call(API.webhooks.test, payload);
    yield put(Actions.testWebhook.success(data));
  } catch (err) {
    yield put(Actions.testWebhook.failure(err));
  }
}
